import React, { useState } from 'react'
import MFAWrapper from 'mfa-wrapper'
import { Button } from 'foundations-library/components'
import { ErrorDialog } from 'functional-foundations'
import PasswordWidget from './../password-management/index'
import { getRemoteValue } from './../../utils'

const texts = getRemoteValue('enable_mfa')

/**
 *
 */
export const PostMFASteps = ({ mfaCompleted, mfaFailed, setMfaFailed }: { mfaCompleted: boolean, mfaFailed: boolean, setMfaFailed: (value: boolean) => void }) => {
    if (mfaFailed) return <ErrorDialog isOpen={mfaFailed} title={texts.mfa_failed} onConfirm={() => setMfaFailed(false)} />
    if (mfaCompleted) return <PasswordWidget openInDialog={true} />
    return null
}

/**
 *
 */
const MFAButton = ({ onClick }: { onClick?: () => void }) => {
    const [mfaCompleted, setMfaCompleted] = useState(false)
    const [mfaFailed, setMfaFailed] = useState(false)

    return (
        <>
            <MFAWrapper sessionKey={texts.session_key} onSessionOpened={onClick} onSessionCompleted={() => setMfaCompleted(true)} onSessionFailed={() => setMfaFailed(true)}>
                <Button variant='contained' color='primary' size='large' icon='go' disabled={mfaCompleted}>
                    {texts.enable_button}
                </Button>
            </MFAWrapper>
            <PostMFASteps mfaCompleted={mfaCompleted} mfaFailed={mfaFailed} setMfaFailed={setMfaFailed} />
        </>
    )
}

export default MFAButton
